var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "document-info rounded",
      style: { "--bg-color": _vm.bgColor }
    },
    [
      _c("div", { staticClass: "row document-info__description" }, [
        _c(
          "div",
          {
            staticClass: "col-12",
            class: _vm.showFilename ? "col-md-5 pr-4" : "col-md-11"
          },
          [
            _c("span", { staticClass: "title" }, [
              _vm._v(" " + _vm._s(_vm.documentTitle) + " ")
            ]),
            _c("p", { staticClass: "content" }, [
              _vm._v(" " + _vm._s(_vm.uploadedFile.documentTypeName) + " ")
            ])
          ]
        ),
        _vm.showFilename
          ? _c(
              "div",
              {
                staticClass:
                  "col-12 col-md-3 pl-md-4 d-md-flex justify-content-md-start"
              },
              [
                _vm.uploadedFile.documentName
                  ? _c("div", [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("Nombre de Archivo:")
                      ]),
                      _c("p", { staticClass: "content" }, [
                        _c("i", { staticClass: "fas fa-file file-icon" }),
                        _vm._v(
                          " " + _vm._s(_vm.uploadedFile.documentName) + " "
                        )
                      ])
                    ])
                  : _vm._e()
              ]
            )
          : _vm._e(),
        _c(
          "div",
          {
            staticClass:
              "col-12 row document-info__description__actions d-flex justify-content-end",
            class: _vm.showFilename ? "col-md-4" : "col-md-1"
          },
          [
            _vm.showActionBtn || _vm.filePreview
              ? _c("action-button", {
                  staticClass: "mr-2",
                  attrs: { i: "fas fa-file-download", variant: "success" },
                  on: {
                    click: function($event) {
                      return _vm.getFile()
                    }
                  }
                })
              : _vm._e(),
            _vm.canReplaceDenied || _vm.canReplaceRequested
              ? _c("action-button", {
                  attrs: { i: "fas fa-file-plus", variant: "outline-success" },
                  on: { click: _vm.openReplaceFileDialog }
                })
              : _vm._e(),
            _c("input", {
              ref: "replaceFileRef",
              staticStyle: { display: "none" },
              attrs: { accept: ".pdf", type: "file" },
              on: { change: _vm.replaceFile }
            }),
            _vm.canRequestReplacementApproved
              ? _c("action-button", {
                  staticClass: "custom-yelow-variant",
                  attrs: { i: "fas fa-arrow-from-right" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("request-replacement")
                    }
                  }
                })
              : _vm._e(),
            _vm.showActionBtn
              ? _c("action-button", {
                  staticClass: "mr-2",
                  attrs: { i: "fas fa-check", variant: "outline-success" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("manageDocumentStatus", true)
                    }
                  }
                })
              : _vm._e(),
            _vm.showActionBtn
              ? _c("action-button", {
                  attrs: { i: "fas fa-ban", variant: "outline-danger" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("manageDocumentStatus", false)
                    }
                  }
                })
              : _vm._e(),
            _vm.addFile
              ? _c("validation-provider", {
                  attrs: { name: "fileUpload", rules: "required" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _vm.addFile
                              ? _c("custom-file-input", {
                                  ref: "fileUpload",
                                  class: _vm.customAddFile
                                    ? "custom-upload-document"
                                    : "upload-document",
                                  attrs: {
                                    accept: ".pdf",
                                    "attachment-id":
                                      _vm.uploadedFile.documentId,
                                    "custom-error-msg":
                                      "El documento de enmienda es requerido.",
                                    "display-style": "normal",
                                    error: errors[0],
                                    name: _vm.uploadedFile.documentName,
                                    "on-download": _vm.getFile,
                                    required: ""
                                  },
                                  model: {
                                    value: _vm.file,
                                    callback: function($$v) {
                                      _vm.file = $$v
                                    },
                                    expression: "file"
                                  }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    3041486790
                  )
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _vm.show
        ? _c("document-preview", {
            attrs: {
              "document-name": _vm.uploadedFile.documentName,
              "document-src": _vm.documentSrc,
              show: _vm.show
            },
            on: { close: _vm.closeModal }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }